import cookie from "react-cookies";
import {KEYS_COOKIES} from "../constants/enums";

const cookieOptions = {
  path: "/",
  maxAge: 7200,
  domain: KEYS_COOKIES.COOKIE_DOMAIN,
  secure: true, // comment out to test on localhost in safari
  httpOnly: false
}

export function setCookieItem(key, data) {
  cookie.save(key, data, cookieOptions)
}

export function getCookieItem(key) {
  return cookie.load(key)
}

export function removeCookieItem(key) {
  cookie.remove(key, cookieOptions)
}

export function getAllCookie() {
  cookie.loadAll()
}
